module.exports = __webpack_public_path__ + "img/bottom_right.580a9d38.png";